// import all icons for sprite generation, attention: webpack spcific syntax here
// sprite gets generated in public/static/build/img/iconsprite.svg
require.context('../../icons/sprite', true, /\.svg$/);
